var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "chip-wrapper",
      class: [
        {
          active: !_vm.displayOnly && _vm.chipValue === _vm.activeChip,
          disabled: _vm.disabled,
          displayOnly: _vm.displayOnly,
        },
      ],
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.updateActiveChipHandler.apply(null, arguments)
        },
      },
    },
    [
      _vm._t("default"),
      _c("span", { staticClass: "chip-value", class: _vm.fontSizeStyle }, [
        _vm._v(" " + _vm._s(_vm.convertedChipValue) + " "),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }